import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { Talent } from "@tvg/ts-types/Talent";
import type { TalentPickServiceData } from "@tvg/ts-types/TalentPicks";
import { getAccountNumber } from "@urp/store-selectors";
import tpm from "@tvg/api/tpm";

const useGetTalentPicksList = (skip: boolean, isTalent: boolean) => {
  const accountNumber = useSelector(getAccountNumber);

  const [isLoading, setIsLoading] = useState(false);
  const [talentPicks, setTalentPicks] = useState<TalentPickServiceData[]>([]);
  const [accountTalentId, setAccountTalentId] = useState<string>();

  const fetchTalentPicks = useCallback(async () => {
    setIsLoading(true);

    try {
      let response;

      if (isTalent) {
        const fetchId =
          accountTalentId ??
          (await (async () => {
            const { data: talents } = await tpm.getAllTalents({
              isActive: true
            });
            const accountTalent = talents.find(
              (talent: Talent) => talent.tvgAccountId === accountNumber
            );
            if (accountTalent?.talentId) {
              setAccountTalentId(accountTalent.talentId);
              return accountTalent.talentId;
            }
            return undefined;
          })());

        if (fetchId) {
          response = await tpm.getTalentPicks(fetchId);
        }
      } else {
        response = await tpm.getWagerOpsPicks();
      }

      setTalentPicks(response);
    } catch (error) {
      console.error("Error fetching talent picks:", error);
    } finally {
      setIsLoading(false);
    }
  }, [isTalent, accountTalentId, accountNumber]);

  useEffect(() => {
    if (!skip) {
      fetchTalentPicks();
    }
  }, [skip]);

  return {
    talentPicks,
    isLoading,
    refetchTalentPicksList: fetchTalentPicks
  };
};

export default useGetTalentPicksList;
